import { getApi } from "./api_instance";

export const getUserProfile = async (dispatch) => {
  try {
    return await getApi({
      apiUrl: "/api/user/profile",
      dispatch,
      sendToken: true,
    });
  } catch (error) {
    throw error;
  }
};
